import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import EditorTheme from '~/modules/page-builder/component/common/rich-text/editor-theme';

export const SingleParagraphContainer: StyleRule = ({ theme }) => ({
    maxWidth: '100%',
    fontSize: pxToRem(16),
    margin: '0 auto',
    padding: pxArrayToRem([0, 34, 0, 18]),

    [theme.screen.min.laptop]: {
        maxWidth: pxToRem(900),
    },
});

export const H3Container: StyleRule = ({ theme }) => ({
    maxWidth: '100%',
    padding: pxArrayToRem([0, 20, 0, 19]),

    [`& .${EditorTheme.heading.h2}`]: {
        textAlign: 'left',
        padding: 0,
        marginBottom: pxToRem(15),
    },

    [theme.screen.min.laptop]: {
        padding: pxArrayToRem([0, 18]),
        maxWidth: pxToRem(1240),
        margin: '0 auto',
        [`& .${EditorTheme.heading.h2}`]: {
            textAlign: 'center',
            marginBottom: pxToRem(25),
        },
    },
});

export const QuoteContainer: StyleRule = ({ theme }) => ({
    maxWidth: '100%',
    padding: pxArrayToRem([0, 18]),

    [theme.screen.min.laptop]: {
        maxWidth: pxToRem(900),
        margin: '0 auto',
    },
});
